import { registerEffectHandler, registerCoeffectHandler, coeffect, dispatch } from 'reffects';

function cookieSet(cookieToSet) {
  return {
    'cookie.set': cookieToSet
  };
}

function registerSetCookieEffect(cookiesClient) {
  registerEffectHandler('cookie.set', function setCookie(newCookie) {
    cookiesClient.set(newCookie);
  });
}

function cookieRemove({ key, path, domain }) {
  return {
    'cookie.remove': {
      key,
      path,
      domain,
    },
  };
}

function registerRemoveCookieEffect(cookiesClient) {
  registerEffectHandler('cookie.remove', function removeCookie({
    key,
    path,
    domain,
  }) {
    cookiesClient.remove(key, { path, domain });
  });
}

function cookieGet(key) {
  return coeffect('cookie', key);
}

function registerGetCookieCoeffect(cookiesClient) {
  registerCoeffectHandler('cookie', function cookie(key) {
    return {
      cookie: {
        [key]: cookiesClient.get(key),
      },
    };
  });
}

const registerSetCookieEffect$1 = registerSetCookieEffect;
const registerGetCookieCoeffect$1 = registerGetCookieCoeffect;

const cookies = {
  get: cookieGet,
  set: cookieSet,
  remove: cookieRemove,
};

function registerCookiesBatteries(cookieClient) {
  registerSetCookieEffect(cookieClient);
  registerRemoveCookieEffect(cookieClient);
  registerGetCookieCoeffect(cookieClient);
}

const COEFFECT_ID = 'globals';

function getPathArray(path) {
  return Array.isArray(path) ? path : path.split('.');
}

function getIn(obj, path, defaultValue = null) {
  if (typeof path === 'undefined') {
    return defaultValue;
  }

  return getPathArray(path).reduce((segment, index) => {
    return segment && segment[index];
  }, obj);
}

function globalsGet(path) {
  return coeffect(COEFFECT_ID, path);
}

function registeGlobalCoeffect(globalObject = window) {
  registerCoeffectHandler(COEFFECT_ID, function global(variableName) {
    const valuesToRetrieve = typeof variableName === 'string' ? { [variableName]: variableName } : variableName;
    const values = Object.fromEntries(
        Object.entries(valuesToRetrieve).map(([name, path]) => [name, getIn(globalObject, path)])
    );
    return {
      [COEFFECT_ID]: values,
    };
  });
}

const registerGlobalCoeffect = registeGlobalCoeffect;

const globals = {
  get: globalsGet
};

function registerGlobalBatteries(store) {
  registeGlobalCoeffect(store);
}

function adaptEvent(event) {
  if (Array.isArray(event)) {
    return event;
  }
  if (typeof event === 'string') {
    return [event];
  }
  if (event.payload) {
    return [event.id, event.payload];
  }
  return [event.id];
}

function httpGet({ url, successEvent, errorEvent = [], config}) {
  return {
    'http.get': {
      url,
      successEvent: adaptEvent(successEvent),
      errorEvent: adaptEvent(errorEvent),
      config,
    }
  };
}

function httpPost({ url, body, config = {}, successEvent = [], errorEvent = [], alwaysEvent = [] }) {
  return {
    'http.post': {
      url,
      body,
      config,
      successEvent: adaptEvent(successEvent),
      errorEvent: adaptEvent(errorEvent),
      alwaysEvent: adaptEvent(alwaysEvent),
    }
  };
}

function httpPut({ url, body, successEvent = [], errorEvent = [] }) {
  return {
    'http.put': {
      url,
      body,
      successEvent: adaptEvent(successEvent),
      errorEvent: adaptEvent(errorEvent),
    }
  };
}

function httpPatch({ url, body, successEvent = [], errorEvent = [] }) {
  return {
    'http.patch': {
      url,
      body,
      successEvent: adaptEvent(successEvent),
      errorEvent: adaptEvent(errorEvent),
    }
  };
}

function httpDelete({ url, body, successEvent = [], errorEvent = [] }) {
  return {
    'http.delete': {
      url,
      body,
      successEvent: adaptEvent(successEvent),
      errorEvent: adaptEvent(errorEvent),
    }
  };
}

function registerHttpEffect(
  httpClient,
  dispatch$1 = dispatch
) {
  registerEffectHandler('http.get', function getEffect({
    url,
    successEvent,
    errorEvent = [],
    config = {},
  }) {
    httpClient.get({
      url,
      successFn: dispatchMandatoryEvent('successEvent', successEvent),
      errorFn: dispatchOptionalEvent(errorEvent),
      config
    });
  });

  registerEffectHandler('http.post', function postEffect({
    url,
    body,
    config = {},
    successEvent,
    errorEvent,
    alwaysEvent,
  }) {
    httpClient.post({
      url,
      body,
      config,
      successFn: dispatchOptionalEvent(successEvent),
      errorFn: dispatchOptionalEvent(errorEvent),
      alwaysFn: dispatchOptionalEvent(alwaysEvent),
    });
  });

  registerEffectHandler('http.put', function putEffect({
    url,
    body,
    successEvent = [],
    errorEvent = [],
  }) {
    httpClient.put({
      url,
      body,
      successFn: dispatchOptionalEvent(successEvent),
      errorFn: dispatchOptionalEvent(errorEvent),
    });
  });

  registerEffectHandler('http.patch', function patchEffect({
    url,
    body,
    successEvent = [],
    errorEvent = [],
  }) {
    httpClient.patch({
      url,
      body,
      successFn: dispatchOptionalEvent(successEvent),
      errorFn: dispatchOptionalEvent(errorEvent),
    });
  });

  registerEffectHandler('http.delete', function patchEffect({
    url,
    body,
    successEvent = [],
    errorEvent = [],
  }) {
    httpClient.delete({
      url,
      body,
      successFn: dispatchOptionalEvent(successEvent),
      errorFn: dispatchOptionalEvent(errorEvent),
    });
  });

  function dispatchMandatoryEvent(name, event) {
    return (...data) => {
      if (eventIsUndefined(event)) {
        throw new Error(`Missing ${name}`);
      }
      dispatchEvent(event, data);
    };
  }

  function dispatchOptionalEvent(event) {
    return (...data) => {
      if (eventIsUndefined(event)) {
        return;
      }
      dispatchEvent(event, data);
    };
  }

  function dispatchEvent(event, data) {
    const [id, ...rest] = event;
    dispatch$1({id, payload: data.concat(rest)});
  }

  function eventIsUndefined(event) {
    return !event || (Array.isArray(event) && event.length === 0)
  }
}

const http = {
  get: httpGet,
  post: httpPost,
  put: httpPut,
  patch: httpPatch,
  delete: httpDelete,
};

function registerHttpBatteries(httpClient) {
  registerHttpEffect(httpClient);
}

function queryParamsGet(selectedQueryParams) {
    return coeffect('queryParams', selectedQueryParams);
}

function registerQueryParamsCoeffect(globalObject) {
  registerCoeffectHandler('queryParams', function retrieveQueryParams(
    selectedQueryParams = []
  ) {
    const urlParams = new URLSearchParams(globalObject.location.search);

    const queryParams = selectedQueryParams.reduce(
      function convertQueryParamsToObject(queryParamValues, queryParam) {
        const queryParamValue = urlParams
          .getAll(queryParam)
          .map(function urlDecodeParams(param) {
            return decodeURIComponent(param);
          });

        if (queryParamValue.length === 0) {
          return queryParamValues;
        }

        if (queryParamValue.length === 1) {
          return Object.assign({}, queryParamValues, {
            [queryParam]: queryParamValue[0],
          });
        }

        return Object.assign({}, queryParamValues, {
          [queryParam]: queryParamValue,
        });
      },
      {}
    );

    return {
      queryParams,
    };
  });
}

const registerQueryParamsCoeffect$1 = registerQueryParamsCoeffect;

const queryParams = {
  get: queryParamsGet
};

function registerQueryParamsBatteries(store) {
  registerQueryParamsCoeffect(store);
}

export { cookies, globals, http, queryParams, registerCookiesBatteries, registerGetCookieCoeffect$1 as registerGetCookieCoeffect, registerGlobalBatteries, registerGlobalCoeffect, registerHttpBatteries, registerQueryParamsBatteries, registerQueryParamsCoeffect$1 as registerQueryParamsCoeffect, registerSetCookieEffect$1 as registerSetCookieEffect };
